<template>
    <div style="height: 130px"></div>
    <div class="fixed-bottom mx-0 py-0 bg-black bg-opacity-75 text-center text-white" id="footer">
        <div class="main-menu">
            <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/"><font-awesome-icon :icon="['fas', 'house']" style="font-size:16px" /><br>ホーム</RouterLink></div>
            <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/entry/team"><font-awesome-icon :icon="['fas', 'users']" style="font-size:16px"/><br>エントリ</RouterLink></div>
            <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/match"><font-awesome-icon :icon="['fas', 'layer-group']" style="font-size:16px"/><br>試合</RouterLink></div>
            <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/timetable"><font-awesome-icon :icon="['fas', 'table-cells']" style="font-size:16px" /><br><span class="d-none d-sm-inline">タイムテーブル</span><span class="d-inline d-sm-none">タイムT</span></RouterLink></div>
            <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/rank"><font-awesome-icon :icon="['fas', 'trophy']" style="font-size:16px" /><br>順位</RouterLink></div>
            <!-- <div class="sub-menu more-root" ref="moreRoot">
                <a href="javascript:void(0)" @click="toggleMore" :class="{ 'sub-menu-active': isMoreActive }">
                    <font-awesome-icon :icon="['fas', 'ellipsis']" style="font-size:16px" />
                    <br>メニュー
                </a>
                <div v-if="showMore" class="more-menu">
                    <RouterLink class="more-menu-item" to="/timetable" @click="closeMore">
                        <font-awesome-icon :icon="['fas', 'table-cells']" style="font-size:16px" />&nbsp;
                        <span class="more-menu-text">タイムテーブル</span>
                    </RouterLink>
                    <RouterLink class="more-menu-item" to="/rank" @click="closeMore">
                        <font-awesome-icon :icon="['fas', 'trophy']" style="font-size:16px" />&nbsp;
                        <span class="more-menu-text">順位</span>
                    </RouterLink>
                </div>
            </div> -->
            <!-- <div class="sub-menu"><RouterLink active-class="sub-menu-active" to="/rank"><font-awesome-icon :icon="['fas', 'bars']" style="font-size:16px" /><br>メニュー</RouterLink></div> -->
            <!-- <div class="sub-menu"><a href="javascript:void(0)" @click="reload()" class="btn-block" onclick="gtag('event', 'app-reload-data', {'event_category': 'button','event_label': 'app-reload'});"><font-awesome-icon :icon="['fas', 'arrows-rotate']" style="font-size:16px"/><br>更新</a></div> -->
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { RouterLink, RouterView, useRoute } from 'vue-router'
const emit = defineEmits(['reloadRank', 'doFetch', 'reloadInfo']);
const route = useRoute();

const showMore = ref(false)
const moreRoot = ref(null)

const isMoreActive = computed(() => {
    return route.path === '/rank' || route.path === '/timetable'
})

const closeMore = () => {
    showMore.value = false
}

const toggleMore = () => {
    showMore.value = !showMore.value
}

const onDocumentClick = (e) => {
    if (!showMore.value) return
    const root = moreRoot.value
    if (!root) return
    if (root === e.target || root.contains(e.target)) return
    closeMore()
}

onMounted(() => {
    document.addEventListener('click', onDocumentClick)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', onDocumentClick)
})

const reload = () => {
    if (route.path == '/rank') {
        emit('reloadRank')
    } else if (route.path == '/') {
        emit('doFetch')
    } else if (route.path == '/info') {
        emit('reloadInfo')
    } else {
        console.log("No reload item")
    }
}
</script>

<style scoped>
#footer {
    z-index: 9;
}

.main-menu {
    display: flex;
    font-size: 12px;
}

.sub-menu a {
    display: block;
    text-decoration: none;
    color: #fff;
    padding: 3px 1px 1px 1px;
    margin: 1px 2px 0px 2px;
}

.sub-menu {
    flex: 1;
    border: 0px;
    padding: 7px 1px 1px 1px;
    margin: 3px 2px 3px 2px;
    text-align: center;
    color: #fff;
    text-decoration: none;
    display: block;
}

.more-root {
    position: relative;
}

.more-menu {
    position: absolute;
    bottom: 62px;
    right: 1px;
    min-width: 170px;
    background: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 6px;
    z-index: 999;
}

.more-menu-item {
    display: block;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    text-decoration: none;
    padding: 12px 15px;
    border-radius: 6px;
}

.more-menu-item:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding-bottom: 7px;
}

.more-menu-item:not(:first-child) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.more-menu-text {
    font-size: 14px;
    line-height: 1.2;
}

.more-menu-item:hover {
    background: rgba(255, 255, 255, 0.12);
}

.sub-menu-active {
    flex: 1;
    border: 0px;
    padding: 3px 3px 0px 3px;
    margin: 5px 5px 2px 5px;
    text-align: center;
    color: #fff;
    text-decoration: none;
    display: block;
    border-bottom: 3px solid #d1e7dd;
}
</style>